import { render } from "./scTrend.vue?vue&type=template&id=2a6224bc&scoped=true"
import script from "./scTrend.vue?vue&type=script&lang=js"
export * from "./scTrend.vue?vue&type=script&lang=js"

import "./scTrend.vue?vue&type=style&index=0&id=2a6224bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6224bc"]])

export default __exports__